import { Box, Tab, Tabs } from '@mui/material';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import HistoryIcon from '@mui/icons-material/History';
import type { ReactElement } from 'react';

export type FlashbackMainTab = 'live' | 'history';

export type FlashbackDashboardLocationState = {
  tab?: FlashbackMainTab;
};

export type FlashbackPlaybackLocationState = {
  date?: string;
  startTime?: string;
  /** Timeline segment id from history list (matches `TimelineSegment.id` when available). */
  segmentId?: string;
  fromTab?: FlashbackMainTab;
};

const flashbackTabsSx = {
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '17.5px',
  color: '#4A5565',
  minHeight: '48px',
  padding: '12px 1px',
  flexDirection: 'row',
  borderBottom: 'none',
  backgroundColor: 'transparent',
  borderBottomWidth: 0,
  '& .MuiTabs-indicator': {
    backgroundColor: '#2932E5',
    height: '2px',
  },
  '& .MuiTab-root': {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '17.5px',
    color: '#4A5565',
    minHeight: '48px',
    padding: '12px 16px',
    textTransform: 'none',
    '&.Mui-selected': {
      color: '#2932E5',
    },
    '& .MuiTab-iconWrapper': {
      color: 'inherit',
      marginRight: '8px',
    },
  },
};

interface Props {
  value: FlashbackMainTab;
  onChange: (tab: FlashbackMainTab) => void;
}

export function FlashbackSectionTabs({ value, onChange }: Props): ReactElement {
  const tabIndex = value === 'live' ? 0 : 1;

  return (
    <Box
      sx={{
        flexShrink: 0,
        backgroundColor: '#f2f2f2',
        px: 3,
      }}
    >
      <Tabs
        value={tabIndex}
        onChange={(_, index) => onChange(index === 0 ? 'live' : 'history')}
        sx={flashbackTabsSx}
      >
        <Tab
          label="Live"
          icon={<VideocamOutlinedIcon sx={{ fontSize: 20 }} />}
          iconPosition="start"
          sx={{
            '&.Mui-selected .MuiTab-iconWrapper': {
              color: '#2932E5',
            },
          }}
        />
        <Tab
          label="History"
          icon={<HistoryIcon sx={{ fontSize: 20 }} />}
          iconPosition="start"
          sx={{
            '&.Mui-selected .MuiTab-iconWrapper': {
              color: '#2932E5',
            },
          }}
        />
      </Tabs>
    </Box>
  );
}
